export default {
  brand: "BasetaoSheet",
  nav: {
    spreadsheet: "Spreadsheet",
    guides: "Guides",
    categories: "Catégories",
    review: "Avis",
    shipping: "Livraison",
    home: "Accueil",
    faq: "FAQ",
    shoppingGuide: "Guide d'achat",
    visitMain: "Visiter le site principal",
  },
  search: {
    placeholder: "Rechercher Basetao Spreadsheet, vendeurs, livraison...",
  },
  cta: {
    basetaoSpreadsheet: "Basetao Spreadsheet",
    buyNow: "Acheter maintenant",
    visitMain: "Visiter le site principal",
    explore: "Explorer",
  },
  lang: {
    label: "Langue",
    en: "English",
    fr: "Français",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  },
  notFound: {
    title: "Page introuvable",
    subtitle: "Désolé, la page que vous recherchez n'existe pas ou a peut-être été déplacée.",
    backHome: "Retour à l'accueil",
  },
  categories: {
    title: "Parcourir les catégories de produits",
    subtitle: "Découvrez chaque groupe de produits couvert par le spreadsheet, chacun lié au catalogue principal.",
    shoes: "Chaussures",
    hoodies: "Sweats / Pulls",
    tshirts: "T-Shirts",
    jackets: "Vestes",
    pants: "Pantalons / Shorts",
    headwear: "Couvre-chefs",
    sets: "Ensembles",
    underwear: "Sous-vêtements",
    jersey: "Maillots",
    accessories: "Accessoires",
    bags: "Sacs",
    belts: "Ceintures",
    perfumes: "Parfums",
    other: "Autres articles",
    empty: "Aucune catégorie ne correspond à votre recherche.",
  },
  footer: {
    tagline: "Un centre de ressources indépendant pour les guides Basetao Spreadsheet, vendeurs, livraison, coupons et conseils de sécurité.",
    resources: "Ressources",
    quickLinks: "Liens rapides",
    disclaimer: "Ce site est une ressource d'information indépendante et n'est pas affilié à Basetao. Les liens produits mènent au site principal.",
    copyright: "© 2026 BasetaoSheet. Tous droits réservés.",
    privacy: "Confidentialité",
    terms: "Conditions",
    contact: "Contact",
  },
};